import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";

const Footer = () => {
  const { isUserAuthorized, isManufacturer } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility } = useContext(FooterContext);
  const { userData } = useContext(AuthContext);


  return (
    <footer className="footer-policy">
      {/* Hub Footer Link Layer */}
      <div className="container-fluid text-uppercase d-flex justify-content-center align-items-center">
        <Link className="text-white text-decoration-none Hub-Footer-link"
          to={userData?.is_password_changed ? (isUserAuthorized ? (isManufacturer ? userData.ref_type === "Manufacturer" ? `/statistics`: `/statistics/${userData.id}` : (userData.baa_viewed ? `/cases` : "/pages/baa")) : `/users/sign_in`) : `/users/createuser`}
        >
          Home
        </Link>
        <a href="https://mannkindcorp.com/privacy-policy/" target="_blank"
           className="text-white text-decoration-none Hub-Footer-link">Privacy Policy</a>
        <Link to = {'/pages/baa'} className="text-white text-decoration-none Hub-Footer-link">
          Legal Disclaimer
        </Link>
        <a href="mailto:suggestions@cmcopilot.com" className="text-white text-decoration-none Hub-Footer-link">
          Suggestions
        </a>
      </div>

      <div style={{ backgroundColor: '#f5f5f5' }}>
        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                onClick={changeAccordianVisibility}
                className="accordion-button collapsed px-3 py-1 text-uppercase Hub-Footer-link fw-normal footer-accordian fs-5 "
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                style={{ backgroundColor: '#f5f5f5' }}
              >
                PLEASE SEE IMPORTANT SAFETY INFORMATION AND FULL PRESCRIBING INFORMATION
                {isAccordianShown ? (
                  <i className="bi bi-chevron-down ps-1"></i>
                ) : (
                  <i className="bi bi-chevron-up ps-1"></i>
                )}
              </button>
            </h2>
            <div id="collapseOne" className={`accordion-collapse collapse ${isAccordianShown ? 'show' : ''}`} data-bs-parent="#accordionExample">
              <div style={{ backgroundColor: "#f5f5f5", maxHeight: '50vh', overflowY: 'auto' }}>
                <div className="container">
                  <h5 className="text-center mt-3 text-decoration-underline"><b>PRESCRIBER IMPORTANT SAFETY INFORMATION for Both On-body Infusor and
                    ReadyFlow</b>
                  </h5>
                  <h5 className="fw-bold">INDICATION</h5>
                  <p>
                    FUROSCIX® (furosemide injection), for subcutaneous use is indicated for the treatment of
                    edema (i.e., congestion, fluid overload, or hypervolemia) in pediatric patients who weigh
                    at least 43 kg and adult patients with chronic heart failure or chronic kidney disease (CKD),
                    including the nephrotic syndrome.
                  </p>
                  <p>
                    Safety and efficacy of the FUROSCIX ReadyFlow for pediatric use have not been
                    established.
                  </p>

                  <h5 className="fw-bold">IMPORTANT SAFETY INFORMATION</h5>
                  <h6>Contraindications:</h6>
                  <ul>
                    <li>
                      FUROSCIX is contraindicated in patients with anuria and in patients with a history of
                      hypersensitivity to furosemide or any component of the FUROSCIX formulation.
                    </li>
                    <li>
                      The On-body Infusor is contraindicated in patients with hypersensitivity to medical
                      adhesives.
                    </li>
                  </ul>

                  <h6>Warnings and Precautions:</h6>
                  <ul>
                    <li>
                      Furosemide may cause fluid, electrolyte, and metabolic abnormalities, particularly
                      in patients receiving higher doses, patients with inadequate oral electrolyte intake,
                      and in elderly patients. Serum electrolytes, CO2, BUN, creatinine, glucose, and uric
                      acid should be monitored frequently during furosemide therapy.
                    </li>
                    <li>
                      Excessive diuresis may cause dehydration and blood volume reduction with
                      circulatory collapse and possibly vascular thrombosis and embolism, particularly in
                      elderly patients.
                    </li>
                    <li>
                      Furosemide can cause dehydration and azotemia. If increasing azotemia and
                      oliguria occur during treatment of severe progressive renal disease, discontinue
                      furosemide.
                    </li>
                    <li>
                      Cases of tinnitus and reversible or irreversible hearing impairment and deafness
                      have been reported with furosemide. Reports usually indicate that furosemide
                      ototoxicity is associated with rapid injection, severe renal impairment, the use of
                      higher than recommended doses, hypoproteinemia or concomitant therapy with
                      aminoglycoside antibiotics, ethacrynic acid, or other ototoxic drugs.
                    </li>
                    <li>
                      In patients with severe symptoms of urinary retention, the administration of
                      furosemide can cause acute urinary retention related to increased production and
                      retention of urine. These patients require careful monitoring, especially during the
                      initial stages of treatment.
                    </li>
                    <li>
                      The FUROSCIX ReadyFlow should be held against the abdomen until the yellow
                      plunger rod stops moving and fills the viewing window. This may take about 10
                      seconds.
                    </li>
                    <li>
                      Contact with water or other fluids and certain patient movements during treatment
                      may cause the On-body Infusor to prematurely terminate infusion. Ensure patients
                      can detect and respond to alarms.
                    </li>
                  </ul>

                  <h6>Adverse Reactions:</h6>
                  <ul>
                    <li>
                      The most common adverse reactions with FUROSCIX administration in
                      clinical trials were site and skin reactions including erythema, bruising,
                      edema, and administration site pain.
                    </li>
                  </ul>

                  <p className="fw-bold">Please see the full Prescribing Information
                    (<a target="_blank" href="https://www.furoscix.com/wp-content/uploads/prescribing-information.pdf">www.furoscix.com/prescribing-information.pdf</a>).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
